import axios from "axios-observable";
// import { APIURL } from "../constants/common";
import { flowApiUrl, studioApiUrl } from "../constants/common"

export const getAxiosInstance = (from: any, token:any, rest = {}) => {

  const apiUrl = (from === 'studio') ? studioApiUrl : flowApiUrl

  const axiosInstance = axios.create({
    baseURL: apiUrl,
    timeout: 50000,
    ...rest
  });

  // Add a request interceptor
  axiosInstance.interceptors.request.use(
    function(config:any) {
      // let token = localStorage.getItem("token");
      // if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      // }
      // Do something before request is sent
      return config;
    },
    function(error:any) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  axiosInstance.interceptors.response.use(
    function(response:any) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (response.data.length > 0 || response.status === 200 || response.status === 204) {
        return response.data;
      } else return Promise.reject({ message: "No Result" });
    },
    function(error:any) {
      if (error.response && error.response.status === 401) {
        // document.cookie = "token=; expires=" + new Date(0).toUTCString();
        // localStorage.removeItem("token");
        // window.location.reload();
      }

      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error.response ? error.response.data : error);
    }
  );

  return axiosInstance
}
